import React from 'react';

import { Fade, Paper, Typography } from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';

import { AppTextField, SimpleRichTextEditor } from '@vyce/core/src/components/inputs';

export const FormTitleStep: React.FC = () => {
  const { control } = useFormContext();

  return (
    <Fade in={true} timeout={200}>
      <div>
        <Paper variant="outlined" style={{ padding: 24 }}>
          <Typography variant="body1" color="textSecondary">
            First of all, how should this form be titled?
          </Typography>

          <Controller
            control={control}
            name="title"
            render={({ field }) => (
              <AppTextField
                {...field}
                value={field.value || ''}
                label="Form title"
                margin="normal"
                fullWidth
              />
            )}
          />

          <Controller
            control={control}
            name="description"
            render={({ field }) => (
              <SimpleRichTextEditor
                value={field.value || ''}
                onChange={field.onChange}
                label="Description"
                fullWidth
                rows={3}
              />
            )}
          />
        </Paper>
      </div>
    </Fade>
  );
};
